import {
    useMemo,
} from 'react'
import {
    Navigate,
} from 'react-router-dom'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    SkyNetRouteConfigObject,
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    ContainerManagementDomains,
} from 'app/enums/domain.enums'

import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import Containers from './Containers'
import ContainerSelection from './ContainerSelection'
import ContainerTypes from './ContainerTypes'
import ServiceCenters from './ServiceCenters'

const ContainerManagement = () => {
    const Routes = useContainerManagementRoutes()
    const routesConfig: SkyNetRouteConfigObject<ContainerManagementDomains> = useMemo(() => {
        return {
            [Routes.Containers.route]: <Containers />,
            [Routes.ContainerDashboard.route]: <ContainerSelection />,
            [Routes.ContainerTypes.route]: <ContainerTypes />,
            [Routes.ServiceCenters.route]: <ServiceCenters />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.Containers.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}

export default ContainerManagement
